import * as tslib_1 from "tslib";
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import { getPopImapConfiguration, savePopImapConfiguration } from 'owa-popimap-configuration';
var savePopOption = select({
    optionState: function () { return store; },
    popImapConfigurationState: function () { return getPopImapConfiguration(); },
})(action('savePopOption')(function savePopOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    (state.popImapConfigurationState.popEnabled =
                        state.optionState.popEnabled != null
                            ? state.optionState.popEnabled
                            : state.popImapConfigurationState.popEnabled), (state.popImapConfigurationState.popMessageDeleteEnabled =
                        state.optionState.popMessageDeleteEnabled != null
                            ? state.optionState.popMessageDeleteEnabled
                            : state.popImapConfigurationState.popMessageDeleteEnabled);
                    return [4 /*yield*/, savePopImapConfiguration(state.popImapConfigurationState)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
export default savePopOption;
//# sourceMappingURL=savePopOption.js.map